/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

import { isMobile } from '../../components/breakpoints';

import { GetCategoryFilterValuesInput } from '../../actions/eCommSelectedFilter/ecomm-get-selected-filter-criterias';

import { ITreeViewNode, IEcommSideBarFilterViewProps } from './ecomm-side-bar-filter';

/**
 *
 * EcommSiteMenuView component
 * @extends {React.PureComponent<IEcommSideBarFilterViewProps>}
 */
export class EcommSideBarFilterView extends React.PureComponent<IEcommSideBarFilterViewProps> {
  public state: any = { width: 0, hasMounted: false, checked: [], expanded: [], selectedCategory: undefined };

  private _hasInitiated = false;

  public componentDidMount(): void {
    if (!this.state.hasMounted) {  
      window.addEventListener('resize', this._updateDimensions);

      this.setState({ width: window.innerWidth, hasMounted: true });
    }
  }

  public render(): JSX.Element | null {
    if (!this.state.hasMounted) {
      return null;
    }

    const { config, filterNodes, totalProducts } = this.props;

    const mobileOptions: ITreeViewNode[] = [];
    const desktopOptions: ITreeViewNode[] = [];

    filterNodes.forEach(item => {
      if (this.state.selectedCategory) {
        if (item.value !== this.state.selectedCategory.value) {
          mobileOptions.push(item);
        }
      }

      desktopOptions.push(item);
    });

    if (isMobile(this.state.width)) {
      const displayName = this.state.selectedCategory ? this.state.selectedCategory.name : '';
  
      return (
        <div className='ecomm-side-fliter mobile'>
          <DropdownButton id='dropdown-basic-button' title={displayName} onSelect={this._onDropdownSelect}>
            {mobileOptions.map((item: ITreeViewNode, idx: number) =>
              <Dropdown.Item key={idx} eventKey={item.value}>{item.name}</Dropdown.Item>
            )}
          </DropdownButton>
        </div>
      );
    }

    const title = (window) && (window.sessionStorage.getItem('qFilter') !== null || window.sessionStorage.getItem('qFilter') !== undefined) ? window.sessionStorage.getItem('qFilter') : '';
    const count = `(${totalProducts} ` + `${config.productsText})`;

    return (
      <div className='ecomm-side-filter'>
      <div className='top row'>
        <p className='title col-sm-6'>{title}</p>
        <p className='count col-sm-6'>{count}</p>
      </div>
      <div className='filter'>
        {desktopOptions.map((item: ITreeViewNode, idx: number) => {
          const activeStyle = this.state.selectedCategory !== undefined && this.state.selectedCategory.value === item.value ? 'active' : '';

          return <button key={idx} className={activeStyle} value={item.value} onClick={this._onSelect}>{item.label}</button>
        })}
      </div>
    </div>
    );
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this._updateDimensions);
  }

  public componentDidUpdate() {
    const { context, extendedNodes, filterNodes } = this.props;

    if (extendedNodes.length !== 0 && !this._hasInitiated) {
      const selected: string[] = [];

      selected.push(filterNodes[0].value);

      context.actionContext.update(new GetCategoryFilterValuesInput(), { filteredCategories: selected });

      this.setState({ selectedCategory: filterNodes[0] });

      this._hasInitiated = true;
    } else {
      if (this.state.selectedCategory) {
        const selected: string[] = [];

        selected.push(this.state.selectedCategory.value);
  
        context.actionContext.update(new GetCategoryFilterValuesInput(), { filteredCategories: selected });
      }
    }
  }

  private _onSelect = (event: any) => {
    const { filterNodes } = this.props;

    const result = filterNodes.find(item => item.value === event.currentTarget.value);

    if (result) {
      this.setState({ selectedCategory: result });
    }
  }

  private _onDropdownSelect = (event: any) => {
    const { filterNodes } = this.props;

    const result = filterNodes.find(item => item.value === event);

    if (result) {
      this.setState({ selectedCategory: result });
    }
  }

  private _updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  }; 
}

export default EcommSideBarFilterView;